export default class DraggableScroll {
    constructor(selector, props = {}) {
        this.slider = selector;
        this.additionalProps = props;
        this.sliderRef = null;
        this.isSliding = null;
    }

    init() {
        if (this.slider.hasClass('slick-initialized')) {
            return;
        }

        this.sliderRef = this.slider.slick({
            variableWidth: true,
            arrows: false,
            swipeToSlide: true,
            ...this.additionalProps,
        });

        this.sliderRef.on('beforeChange', () => {
            this.isSliding = true;
        });

        this.sliderRef.on('afterChange', () => {
            this.isSliding = false;
        });
    }
}
